
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-content modal-content-width border-all-10px-modal">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-5px padding-left-15px padding-right-15px">
      <div class="row nav-tab-service2">
        <!--<div class="col-md-8">
          Service Providers List : <label class="margin-bottom-0px color-blue font-size-18px font-weight-normal">
          {{CurrentBillDetails.ServiceDescription}}</label>
        </div>
        <div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
          <form novalidate="" #f="ngForm" class="display-inherit margin-left-auto">
            <div class="clear-form">
              <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
              <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
            </div>
            <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
          </form>
        </div>-->

        <div class="col-md-11">
          <ul class="nav nav-tabs" id="tabContent">
            <li class="active margin-right-15px"><a class="nav-itemerp active" href="#SvcProvider" data-toggle="tab">Svc Provider List</a></li>
            <li class="margin-right-15px"><a class="nav-itemerp" href="#AddNew" data-toggle="tab">Add</a></li>

          </ul>

        </div>
        <div class="col-md-1 padding-left-0px">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.close('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">
      
      <div class="tab-content">
        <div class="tab-pane active" id="SvcProvider">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-bottom-5px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9">
                      Service : <label class="margin-bottom-0px color-blue font-size-18px font-weight-normal">
                        {{CurrentBillDetails.ServiceDescription}}
                      </label>
                    </div>
                    <div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
                      <form novalidate="" #f="ngForm" class="display-inherit margin-left-auto">
                        <!--<input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">-->
                        <div class="clear-form">
                          <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                          <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                        </div>
                        <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                      </form>
                    </div>                    
                  </div>
                </div>

                <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="table-component">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped margin-left-zero "
                             cols="auto,2*,*,*,*,*,*,*">

                        <thead class="">
                          <tr>
                            <th></th>
                            <th class="text-align-center">
                              Provider Code
                            </th>

                            <th class="text-align-left">
                              Name
                            </th>
                            <th class="text-align-right">
                              Cost
                            </th>
                            <th class="text-align-right">
                              Commission
                            </th>

                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let l of CurrentServiceProvidersController">
                            <td class="padding-all-0px">
                              <button type="button" class="btn font-size-13px actions-btn-prime" (click)="ProviderDetails(l)">
                                Select
                              </button>

                            </td>
                            <td class="text-align-center">
                              {{l.ProviderCode}}
                            </td>
                            <td class="text-align-left">

                              {{l.ProviderName}}
                            </td>
                            <td class="text-align-right">{{l.ProviderCost}}</td>
                            <td class="text-align-right">{{l.CommissionAmount}}</td>

                          </tr>

                        </tbody>

                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="tab-pane" id="AddNew">
          <div class="card">
            <div class="card-header wh-header border-bottom padding-bottom-5px padding-left-15px padding-right-15px">
              <div class="row">
                <div class="col-md-9">
                  Service : <label class="margin-bottom-0px color-blue font-size-18px font-weight-normal">
                    {{CurrentBillDetails.ServiceDescription}}
                  </label>
                </div>                
              </div>
            </div>
            <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="row">
                <div class="col-md-12 padding-l-0px">
                  <form class="form" novalidate="" #f="ngForm">
                    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                      <div class="card-body card-body-general padding-top-0px">

                        <div class="row">
                          <div class="col-md-12">


                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-3 text-align-right">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"> Service Provider </label>
                                  </div>
                                  <div class="col-md-3">
                                    <select class="form-control padding-left-0px padding-right-0px" (change)="onChange($event.target)">
                                      <option selected="selected" value=""></option>
                                      <option *ngFor="let l of CurrentDoctorsListController" [value]="l.ProviderCode">
                                        {{l.Prefix}}{{l.DisplayName}}
                                      </option>
                                    </select>
                                  </div>

                                </div>

                              </div>
                            </div>

                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                <div class="row">
                                  <div class="col-md-3 text-align-right">
                                    <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Service Charge</label>
                                  </div>

                                  <div class="col-md-3">
                                    <input type="number" class="form-control" placeholder="Service Charge"
                                           id="CurrentSaveNewServiceProvider.Price"
                                           [(ngModel)]="CurrentSaveNewServiceProvider.Price"
                                           name="CurrentSaveNewServiceProvider.Price" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                           maxlength="30" #Location="ngModel" required>
                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row" >
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                <div class="row">
                                  <div class="col-md-3 text-align-right">
                                    <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Commission Amount</label>
                                  </div>

                                  <div class="col-md-3">
                                    <input type="number" class="form-control" placeholder="Commission Amount"
                                           id="CurrentSaveNewServiceProvider.CommissionAmount"
                                           [(ngModel)]="CurrentSaveNewServiceProvider.CommissionAmount"
                                           name="CurrentSaveNewServiceProvider.CommissionAmount" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                           maxlength="30" >
                                  </div>
                                </div>


                              </div>
                            </div>

                          </div>


                        </div>
                      </div>
                      <div class="card-footer">
                        <button *ngIf="CanSave"
                                (click)="AddNewProvider()"
                                class="btn actions-btn-prime float-right font-size-13px" [disabled]="!f.form.valid">Save</button>
                        <button *ngIf="CanUpdate"
                                (click)="UpdateProvider()"
                                 class="btn actions-btn-prime float-right font-size-13px" [disabled]="!f.form.valid">Update</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
    <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

    </div>-->

  </div>
</div>
